<style>
  #MainDivCat *{
    font-weight: bolder;
    font-size: 14px;
    list-style: none;
  }
</style>

<div class="col-md-12 mb-30" >
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Organizational Chart</h5>

      <div id="MainDivCat" >
        <ul droppable>
          <li class="MyMoeinListCat_Li" draggable>

            <div class="MyMoeinListCat_Div">
              <span class="MyMoeinListCat_Span">Root</span>
              <i class="fa  fa-plus-circle MyMoeinListCat_Add" (click)="On_Add_Root(templateAdd)"></i>
            </div>

            <app-Chart_Co

              (On_Add_Action)="OnGet_Add_Action(templateAdd,$event)"

              (On_Edit_Action)="OnGet_Edit_Action(templateEdit,$event)"
              (On_Remove_Action)="OnGet_Remove_Action(templateDelete,$event)"
              (On_Remove_Person_Action)="OnGet_Remove_Person_Action(templateDeletePerson,$event)"

              (On_Up_Action)="OnGet_Up_Action($event)"
              (On_Down_Action)="OnGet_Down_Action($event)"
              (On_Child_Action)="OnGet_Child_Action($event)"
              (On_Cut_Action)="OnGet_Cut_Action($event)"
              (On_Person_Action)="OnGet_Person_Action(templatePerson,$event)"

              [inner_17025_Cat]="DataList_Chart">

            </app-Chart_Co>

          </li>
        </ul>
      </div>

    </div>
  </div>
</div>




<ng-template #templateEdit>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Edit Position</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Edit.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Title </label>
        <input [(ngModel)]="title_edit" name="title_edit" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> Membership Fee </label>
        <input [(ngModel)]="haghOzviayt_edit" name="haghOzviayt_edit" type="number" class="form-control"
          placeholder="Type here...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> Job Coefficient </label>
        <input [(ngModel)]="positionGrid_edit" name="positionGrid_edit" type="number" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="Edit()"> Edit <i class="fa fa-edit"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Edit.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateAdd>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Add Position </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Add.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Title </label>
        <input [(ngModel)]="Add_Step_Title" name="title_add" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" [hidden]="Selected_Chart.id==0" (click)="Add(1)"> Add at Same Level <i class="fa fa-plus"></i></button>
    <button type="button" class="btn btn-info" (click)="Add(0)"> Add at Child Level  <i class="fa fa-plus"></i></button>

    <button type="button" class="btn btn-danger" (click)="modalRef_Add.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateDelete>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Position</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="Delete(1)"> Delete and Move Children Up <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-info" (click)="Delete(0)"> Delete with Children  <i class="fa fa-remove"></i></button>


    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateDeletePerson>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete '{{Selected_Chart_Person.fullname}} '</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Person_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="Delete_Person()"> Delete <i class="fa fa-remove"></i></button>

    <button type="button" class="btn btn-danger" (click)="modalRef_Person_Delete.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templatePerson>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Personnel List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Person.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Last Name</label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Last Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Person
            |filter:Filter_Familly:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: Personpage,
                        totalItems: (DataList_Person
                        |filter:Filter_Familly:'fullname'
                        ).length
                      }
            ">
              <td>{{DataList_Person.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td (click)="Set_Selected_Person_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_Person" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_Person" type="button" (click)="ReadData_Person()"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Person.hide()">Close</button>
  </div>
</ng-template>